export enum EPropertyManagementUrl {
  PROPERTY_MANAGEMENT = 'property-management',
  NAME = 'name',
}
